<template>
    <div class="table-box">
      <global-tag>
        <el-form
          :inline="true"
          :model="searchlist"
          class="demo-form-inline"
          size="mini"
        >
          <el-form-item label="用户名:">
            <el-input
              v-model="searchlist.operName"
              placeholder="请输入用户名"
              style="width: 130px"
            ></el-input>
          </el-form-item>
          <el-form-item label="操作日期：">
            <el-date-picker
              v-model="searchlist.logTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="searchlistdata"
            >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button type="info" @click="searchlistReset"
            >重置</el-button
            >
          </el-form-item>
          <el-form-item></el-form-item>
        </el-form>
      </global-tag>

      <div class="three">
        <el-button
          type="danger"
          size="mini"
          @click="createExcel"
        >按条件导出</el-button
        >
      </div>
      <!-- 表格盒子 -->
      <div class="table_card">
        <el-table
          :data="tableData"
          :header-cell-style="{ background: '#f8fafa' }"
          border
          align="center"
          current-row-key
          highlight-current-row
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form
                label-position="left"
                inline
                class="demo-table-expand"
              >
                <el-form-item label="请求参数:">
                                            <span>{{
                                                props.row.operParam
                                              }}</span>
                </el-form-item>
                <el-form-item label="返回参数:">
                                            <span>{{
                                                props.row.jsonResult
                                              }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="operName"
            label="用户名"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="operIp"
            label="IP"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="operLocation"
            label="IP来源"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="title"
            label="模块"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="requestMethod"
            label="操作类型"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="method"
            label="操作内容"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="processingTime"
            label="请求耗时"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.processingTime <= 300"
              >{{
                  scope.row.processingTime
                }}ms</el-tag
              >
              <el-tag
                v-else-if="
                                            scope.row.processingTime <= 1000
                                        "
                type="warning"
              >{{
                  scope.row.processingTime
                }}ms</el-tag
              >
              <el-tag v-else type="danger"
              >{{
                  scope.row.processingTime
                }}ms</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="operUrl"
            label="操作路径"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="operTime"
            label="操作时间"
          ></el-table-column>
        </el-table>
        <el-pagination
          :page-size="pageConfig.pageSize"
          layout="total, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          :total="pageConfig.total"
        ></el-pagination>
      </div>
    </div>
</template>

<script>
import "@/assets/css/system.css"
import echarts_msg from "../../../utils/echarts.js"
import request from "../../../utils/request.js"
export default {
    data() {
        return {
            chartTime: "",
            topUserList: [],
            multipleSelection: [],
            searchlist: {},
            tableData: [],
            pageConfig: {
                pageSize: 10,
                total: 0,
                pageNo: 1,
            },
        }
    },
    methods: {
        //条件查询
        searchlistdata() {
            this.pageConfig.pageNo = 1
            this.getPageDatas()
        },
        searchlistReset() {
            this.searchlist = {}
            this.pageConfig.pageNo = 1
            this.getPageDatas()
        },
        //分页
        handleCurrentChange(val) {
            this.pageConfig.pageNo = val
            this.getPageDatas()
        },
        //获取列表数据
        async getPageDatas() {
            this.searchlist.pageNo = this.pageConfig.pageNo
            this.searchlist.pageSize = this.pageConfig.pageSize
            this.searchlist.qujiId = JSON.parse(
                localStorage.getItem("czUserInfo")
            ).qujiId
            this.searchlist.shengjiId = JSON.parse(
                localStorage.getItem("czUserInfo")
            ).shengjiId
            this.searchlist.shijiId = JSON.parse(
                localStorage.getItem("czUserInfo")
            ).shijiId
            this.searchlist.stationId = JSON.parse(
                localStorage.getItem("czUserInfo")
            ).stationId
            this.searchlist.shequjiId = JSON.parse(
                localStorage.getItem("czUserInfo")
            ).shequjiId
            let params = JSON.stringify(this.searchlist)
            console.log(params)
            var res = await request({
                url: "/rbac/admin/system/log/list",
                method: "POST",
                data: params,
            })
            if (res.code == 200) {
                if (res.content != null) {
                    this.pageConfig.total = res.content.count
                    this.tableData = res.content.list
                    this.tableData.forEach((item) => {
                        item.operParam = item.operParam.replace(/\\"/g, '"')
                    })
                } else {
                    this.pageConfig.total = 0
                    this.tableData = []
                }
            } else if (res.code == "10004") {
                this.$message.error(res.message)
                this.$router.push("/login")
            } else {
                console.log(res)
                this.$message({
                    message: "数据加载异常",
                    type: "error",
                })
            }
        },
        //导出excel
        async createExcel() {
            let params = JSON.stringify(this.searchlist)
            const res = await this.request2({
                url: "/rbac/admin/system/log/export",
                method: "POST",
                data: params,
                responseType: "blob",
            })
            const blob = new Blob([res], { type: "application/vnd.ms-excel" })
            const fileName = "用户日志信息.xls"
            const linkNode = document.createElement("a")

            linkNode.download = fileName //a标签的download属性规定下载文件的名称
            linkNode.style.display = "none"
            linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
            document.body.appendChild(linkNode)
            linkNode.click() //模拟在按钮上的一次鼠标单击

            URL.revokeObjectURL(linkNode.href) // 释放URL 对象
            document.body.removeChild(linkNode)
        },
        handleSelectionChange(val) {
            // console.log(val)
            this.multipleSelection = val
        },
    },
    mounted() {
        this.getPageDatas()
    },
}
</script>
<style lang="less" scoped>
.oneleft {
    float: left;
    width: 35%;
    margin-top: 25%;
    height: 30%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: space-between;
    text-align: center;
    flex-wrap: wrap;
    div:first-child {
        width: 100%;
        color: red;
        font-size: 30px;
    }
    div:last-child {
        width: 100%;
    }
}
.oneright {
    float: left;
    width: 65%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-content: space-around;
    flex-wrap: wrap;
    .onerighttop {
        width: 85%;
        height: 40%;
        margin-top: 5%;
    }
    .onerightbottom {
        width: 85%;
        height: 40%;
    }
}
.onebuttom-query {
    width: 100%;
    height: 35px;
    text-align: right;
}
.onebuttom-chart {
    width: 100%;
    height: calc(100% - 30px) !important;
}
.demo-table-expand {
    font-size: 0;
}
.demo-table-expand label {
    width: 70px;
    color: #99a9bf;
}
.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
}
.demo-table-expand .el-form-item__content {
    font-size: 12px;
}
</style>
